/* eslint-disable no-undef */
import { useTranslation } from 'react-i18next';
import {
    Box,
    Card,
    CardMedia,
    CardContent,
    CardActions,
    Link,
    Typography,
} from '@mui/material';
import './styles.css';
import { ReactComponent as LocationIcon } from '../../assets/icons/location.svg'

const ProductCard = ({ imageUrl, location, price, rate, reviews, title, path }) => {
    const { t } = useTranslation(['tours', 'components']);
    const image = imageUrl;
    const priceFrom = typeof price === 'object' ? price?.from : price;
    const priceTax = typeof price === 'object' ? (price?.tax ?? price?.iva) : undefined;
    const priceCurrency = typeof price === 'object' ? (price?.currency || '€') : '€';
    return (
        <Link href={path} sx={{ textDecoration: "none" }} title={"Más información sobre " + title}>
            <Card
                id="productCard"
                sx={{
                    maxWidth: 340,
                    width: { xs: 'auto', md: 340 },
                    height: { xs: 380, md: 420 },
                    boxShadow: 10,
                    borderRadius: 2
                }}>
                <CardMedia
                    sx={{
                        marginBottom: -2,
                        transition: 'filter 0.5s ease-in-out',
                        filter: 'brightness(100%)',
                        [`#productCard:hover &`]: {
                            filter: 'brightness(60%)'
                        },
                    }}
                    image={image}
                    title={title}
                />
                <Box
                    className="productCardContent"
                    sx={{
                        px: { xs: 0, md: '.8rem' },
                        padding: { xs: '12px', md: '24px' },
                        width: '100%',
                        bgcolor: '#ffffff',
                        transition: 'background-color 1.0s',
                        position: 'absolute',
                        paddingBottom: '15px',
                        bottom: 0,
                        [`#productCard:hover &`]: {
                            bgcolor: 'transparent'
                        },
                        height: { xs: '220px', md: '260px' }
                    }}>
                    <CardContent sx={{ padding: 0, pb: '8px' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                pb: '.5rem',
                                px: 0,
                                pt: 0,
                            }}>
                            <LocationIcon
                                height={18}
                                width={12}
                                style={{ marginRight: '.5rem', marginTop: '.2rem' }}
                            />
                            <Typography
                                variant="body2"
                                color="#666B6E"
                                fontFamily={'Inter'}
                                fontSize={{ xs: '14px', md: 17 }}
                                fontWeight={350}
                            >
                                {location}
                            </Typography>
                        </Box>
                        <Typography component="h3" variant="subtitle1">{title}</Typography>
                    </CardContent>
                    <CardActions sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                        padding: 0,
                        marginBottom: 1,
                    }}
                    >
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 1,
                        }}>
                            <Box
                                sx={{
                                    width: { xs: 35, md: 50 },
                                    height: { xs: 25, md: 35 },
                                    borderRadius: { xs: '5px', md: 2 },
                                    bgcolor: 'secondary.main',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginLeft: 0.5,
                                }}>
                                <Typography
                                    variant="h6"
                                    color="primary.contrastText"
                                    sx={{ fontWeight: { xs: '450', md: 'bold' }, fontSize: { xs: '0.9rem', md: '1.25rem' } }}>
                                    {rate}
                                </Typography>
                            </Box>
                            <Typography
                                pl={1}
                                fontFamily={'Poppins'}
                                sx={{
                                    display: { xs: 'none', md: 'flex' }
                                }}>
                                {`${reviews.state}`}
                            </Typography>
                            <Typography
                                fontFamily={'Poppins'}
                                sx={{
                                    fontSize: { xs: '14px', md: '16px' }
                                }}>
                                {`(${reviews.number} Reviews)`}
                            </Typography>
                        </Box>
                        <Box sx={{ py: 0, ml: '.3rem' }}>
                            <Typography
                                color="secondary"
                                sx={{
                                    fontSize: { xs: '14px', md: '18px' },
                                    fontWeight: { xs: 600, md: 700 }
                                }}>
                                {`${priceFrom} ${priceCurrency}`}
                            </Typography>
                            <Typography
                                color="grayText"
                                sx={{
                                    fontSize: { xs: '10px', md: '12px' },
                                    fontWeight: 400
                                }}>
                                {priceTax > 0 ? t('IVANotincluded') : ''}
                            </Typography>
                        </Box>
                    </CardActions>
                    {/* <CardActions sx={{ py: 0, ml: '.3rem' }}>
                        <Typography
                            color="grayText"
                            sx={{
                                fontSize: { xs: '10px', md: '12px' },
                                fontWeight: 400
                            }}>
                            {t('IVAincluded')}
                        </Typography>
                    </CardActions> */}
                </Box>
            </Card>
        </Link>
    )
}

export default ProductCard
